/* eslint-disable no-plusplus */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import React, { ReactElement, useContext, useEffect, useState } from 'react'

import { Button, Col, Form, Input, Row, Spin } from 'antd'
import { FormInstance } from 'antd/es/form/Form'
import { SelectFieldAnt } from 'Components/Form'
import { SelectItemProps } from 'Components/Form/Select'
import ID_COMPONENTE from 'config/idComponente'
import { ApplicationContext } from 'Context'
import classificacaoHorarios from 'Helpers/classificacaoHorarios'
import Veiculos from 'Helpers/Veiculos'
import Claims from 'Hooks/usePermissions/Claims'
import usePermissions from 'Hooks/usePermissions/usePermissions'
import { Empresa, Veiculo } from 'Models/cadastros'
import { IArmazem, ICandidato, IDoca, IHorario, IJanela } from 'Models/docas'
import IAgendamentoModoCompacto from 'Models/docas/IAgendamentoModoCompacto'
import IArmazemCota from 'Models/docas/IArmazemCota'
import IDadosAdicionaisViagem from 'Models/docas/IDadosAdicionaisViagem'
import IFormAgendamentoBiomassa from 'Models/docas/IFormAgendamentoBiomassa'
import IFormArmazemCotaFilter from 'Models/docas/IFormArmazemCotaFilter'
import IFormModoCompacto from 'Models/docas/IFormModoCompacto'
import IFormModoCompactoIraniFob from 'Models/docas/IFormModoCompactoIraniFob'
import { STATUS_HORARIOS } from 'Models/docas/IHorario'
import IVeiculoTransportadora from 'Models/docas/IVeiculoTransportadora'
import moment from 'moment'
import { useForm } from 'react-hook-form'
import { useSnackbar } from 'react-simple-snackbar'
import { ParamsRequest } from 'Services/__shared/types/resquest'
import WsCadastroService from 'Services/WS_CADASTRO'
import WsDocasService from 'Services/WS_DOCAS'
import { MsgSuccessOptions } from 'Types/SnackbarTypes'
import IFormEmpresasFilter from 'Views/Cadastros/Empresas/IFormEmpresasFilter'

import { DocasContext } from './Context/context'

interface IProps {
  armazem: Partial<IArmazem>
  agendamentos: IAgendamentoModoCompacto[]
  selectTransportadoraItens: SelectItemProps[]
  cdTransportadoraUsuario?: number
  atualizaAgenda: (
    limparSelecao?: boolean,
    executandoAcao?: boolean,
  ) => Promise<void>
}

const ModoCompactoIraniFob = ({
  armazem,
  agendamentos,
  selectTransportadoraItens,
  cdTransportadoraUsuario,
  atualizaAgenda,
}: IProps): ReactElement => {
  const hookForm = useForm()
  const [form] = Form.useForm()
  const { isAuthorized } = usePermissions()
  const { docasContext, setDocasContext } = useContext(DocasContext)
  const { applicationContext, setApplicationContext } =
    useContext(ApplicationContext)
  const [carregandoAgendaSimplificada, setCarregandoAgendaSimplificada] =
    useState<boolean>(false)
  const [carregandoReservaHorario, setCarregandoReservaHorario] =
    useState<boolean>(false)
  const [selectJanelaItens, setSelectJanelaItens] = useState<SelectItemProps[]>(
    [],
  )
  const [selectDocaItens, setSelectDocaItens] = useState<SelectItemProps[]>([])
  const [selectHorarioItens, setSelectHorarioItens] = useState<
    SelectItemProps[]
  >([])
  const [horarios, setHorarios] = useState<IHorario[]>([])
  const [cdJanela, setCdJanela] = useState<number>()
  const [cdDoca, setCdDoca] = useState<number>()
  const [openSnackbarSuccess, closeSnackbarSuccess] =
    useSnackbar(MsgSuccessOptions)
  const [cdTransportadora, setCdTransportadora] = useState<number | undefined>(
    cdTransportadoraUsuario,
  )
  const [placa1, setPlaca1] = useState<string>()
  const [placa2, setPlaca2] = useState<string>()
  const [veiculo, setVeiculo] = useState<IVeiculoTransportadora>()
  const [criarVeiculo, setCriarVeiculo] = useState<boolean>(false)
  const [verificandoVeiculo, setVerificandoVeiculo] = useState<boolean>(false)
  const [criandoVeiculo, setCriandoVeiculo] = useState<boolean>(false)

  const [reservarAprovar, setReservarAprovar] = useState<boolean>(false)

  const buscaUltimoHorario = (cdJanela: number, horarios: IHorario[]) => {
    const horariosJanela = horarios
      .filter((horario) => horario.cdAgendamentoDocasJanela === cdJanela)
      .sort((a, b) =>
        a.cdAgendamentoDocasHorario > b.cdAgendamentoDocasHorario ? -1 : 1,
      )

    return moment(horariosJanela[0].dtHora, 'YYYY-MM-DDTHH:mm:ss')
  }

  const getAgendaSimplificada = async () => {
    if (docasContext.armazemAtual) {
      setCarregandoAgendaSimplificada(true)

      const dataMinima: moment.Moment = moment()
      // const horas: number = dataMinima.hours()
      // const minutos: number = dataMinima.minutes()

      // dataMinima.set('hour', minutos > 0 ? horas + 2 : horas + 1)
      dataMinima.set('minute', 0)
      dataMinima.set('second', 0)
      dataMinima.set('millisecond', 0)

      const { data } = await WsDocasService.agenda.getAgendaSimplificada(
        ID_COMPONENTE.DOCAS,
        docasContext.armazemAtual.cdAgendamentoDocasArmazemConfig!,
        docasContext.dataAtual!.format('YYYY-MM-DD HH:mm:ss'),
      )

      if (data.item) {
        setSelectJanelaItens(
          data.item.janelas.map((janela: IJanela) => {
            return {
              value: janela.cdAgendamentoDocasJanela.toString(),
              label: janela.nomeJanela,
              disabled:
                buscaUltimoHorario(
                  janela.cdAgendamentoDocasJanela,
                  data.item!.horarios,
                ) < dataMinima,
            }
          }),
        )

        setSelectDocaItens(
          data.item.docas.map((doca: IDoca) => {
            return {
              value: doca.cdAgendamentoDocasDocas.toString(),
              label: doca.nomeDoca,
            }
          }),
        )

        setHorarios(data.item.horarios)
      }

      if (cdJanela && cdDoca) {
        verificaHorariosDisponiveis()
      }

      setCarregandoAgendaSimplificada(false)
    }
  }

  const verificaLetra = (texto: string) => {
    return /^[a-zA-Z]$/.test(texto)
  }

  const verificaNumero = (texto: string) => {
    return !window.isNaN(+texto)
  }

  const verificaLetraOuNumero = (texto: string) => {
    return verificaLetra(texto) || verificaNumero(texto)
  }

  const verificaPlaca = (placa: string): boolean => {
    return (
      placa.length === 7 &&
      verificaLetra(placa[0]) &&
      verificaLetra(placa[1]) &&
      verificaLetra(placa[2]) &&
      verificaNumero(placa[3]) &&
      verificaLetraOuNumero(placa[4]) &&
      verificaNumero(placa[5]) &&
      verificaNumero(placa[6])
    )
  }

  const verificaVeiculo = async () => {
    if (placa1 && verificaPlaca(placa1)) {
      if (cdTransportadora) {
        setVerificandoVeiculo(true)

        const veiculo: IVeiculoTransportadora | undefined =
          await WsDocasService.veiculo.buscaVeiculo(
            ID_COMPONENTE.DOCAS,
            placa1,
            cdTransportadora,
          )

        if (veiculo) {
          setVeiculo(veiculo)
          openSnackbarSuccess(
            `Tudo certo, o veículo ${placa1} já está cadastrado para a sua transportadora`,
          )
        } else {
          setCriarVeiculo(true)
          openSnackbarSuccess(
            `O veículo ${placa1} ainda não está cadastrado para a sua transportadora. Clique no botão "Criar" para continuar`,
          )
        }

        setVerificandoVeiculo(false)
      } else {
        openSnackbarSuccess('Selecione uma transportadora antes de continuar')
      }
    } else {
      openSnackbarSuccess(
        `A placa ${placa1} é inválida, corrija para o formato ABC1234 ou ABC1D23`,
      )
    }
  }

  const criaVeiculo = async () => {
    if (placa1 && verificaPlaca(placa1)) {
      if (cdTransportadora) {
        setCriandoVeiculo(true)

        const veiculo: IVeiculoTransportadora | undefined =
          await WsDocasService.veiculo.criaVeiculo(
            ID_COMPONENTE.DOCAS,
            placa1,
            cdTransportadora,
          )

        if (veiculo) {
          setVeiculo(veiculo)
          openSnackbarSuccess(`Veículo ${placa1} criado com sucesso`)

          Veiculos.get(true)
        } else {
          openSnackbarSuccess(
            `Ocorreu um erro ao criar o veículo ${placa1}, favor contatar o suporte do Compulog`,
          )
        }

        setCriarVeiculo(false)
        setCriandoVeiculo(false)
      } else {
        openSnackbarSuccess('Selecione uma transportadora antes de continuar')
      }
    } else {
      openSnackbarSuccess(
        `A placa ${placa1} é inválida, corrija para o formato ABC1234 ou ABC1D23`,
      )
    }
  }

  const reservaHorarios = async (dados: IFormModoCompactoIraniFob) => {
    if (veiculo) {
      if (!placa2 || verificaPlaca(placa2)) {
        if (placa1 !== placa2) {
          setCarregandoReservaHorario(true)

          const cdsHorarios: number[] = dados.cdsHorarios.map((cdHorario) =>
            window.parseInt(cdHorario),
          )

          let horariosOrdenados: IHorario[] = horarios.filter((horario) =>
            cdsHorarios.includes(horario.cdAgendamentoDocasHorario),
          )

          horariosOrdenados =
            classificacaoHorarios.ordenaHorarios(horariosOrdenados)

          if (
            classificacaoHorarios.verificaHorariosConsecutivos(
              horariosOrdenados,
              armazem.tamanhoJanelaSecundaria!,
            )
          ) {
            let dadosAdicionaisViagem: IDadosAdicionaisViagem | undefined = {}

            if (dados.numeroLoad) {
              dadosAdicionaisViagem.campo1 = `Numero Load;;${dados.numeroLoad.toUpperCase()}`
            }

            if (dados.destino) {
              dadosAdicionaisViagem.campo2 = `Destino;;${dados.destino.toUpperCase()}`
            }

            if (dados.motorista) {
              dadosAdicionaisViagem.campo3 = `Motorista;;${dados.motorista.toUpperCase()}`
            }

            if (dados.tipoVeiculo) {
              dadosAdicionaisViagem.campo4 = `Tipo Veiculo;;${dados.tipoVeiculo.toUpperCase()}`
            }

            if (placa2) {
              dadosAdicionaisViagem.campo5 = `Placa 2;;${placa2}`
            }

            if (Object.keys(dadosAdicionaisViagem).length === 0) {
              dadosAdicionaisViagem = undefined
            }

            const horariosSemViagem: IFormAgendamentoBiomassa[] = [
              converteFormulario(
                horariosOrdenados[0].cdAgendamentoDocasHorario,
                dados,
                dadosAdicionaisViagem,
              ),
            ]

            for (let i = 1; i < horariosOrdenados.length; i++) {
              horariosSemViagem.push(
                converteFormulario(
                  horariosOrdenados[i].cdAgendamentoDocasHorario,
                  dados,
                ),
              )
            }

            const resposta =
              await WsDocasService.armazemCota.criaAgendamentoBiomassa(
                ID_COMPONENTE.DOCAS,
                horariosSemViagem,
              )

            if (resposta.data.statusCode === 501) {
              await getAgendaSimplificada()
              await atualizaAgenda()

              form.resetFields()
              setCdJanela(undefined)
              setCdDoca(undefined)
              setVeiculo(undefined)
              setPlaca1(undefined)
            } else {
              openSnackbarSuccess(resposta.data.message)
            }
          } else {
            openSnackbarSuccess(
              'Não é possível fazer uma reserva em horários não consecutivos',
            )
          }

          setCarregandoReservaHorario(false)
        } else {
          openSnackbarSuccess(`As duas placas informadas devem ser diferentes`)
        }
      } else {
        openSnackbarSuccess(
          `A placa ${placa2} é inválida, corrija para o formato ABC1234 ou ABC1D23`,
        )
      }
    } else {
      openSnackbarSuccess(
        `${
          criarVeiculo ? 'Crie' : 'Verifique'
        } o veículo ${placa1} antes de continuar`,
      )
    }
  }

  const converteFormulario = (
    cdHorario: number,
    dados: IFormModoCompactoIraniFob,
    dadosAdicionaisViagem?: IDadosAdicionaisViagem,
  ): IFormAgendamentoBiomassa => {
    return {
      cdCandidatoAgendamento: 0,
      cdArmazem: armazem.cdAgendamentoDocasArmazem!,
      cdAgendamentoDocasHorario: cdHorario,
      horarioStatus: reservarAprovar
        ? STATUS_HORARIOS.RESERVADO_APROVADO
        : STATUS_HORARIOS.RESERVADO,
      agendamentoMultiplo: dados.cdsHorarios.length > 1,
      placaVeiculo: veiculo!.placa!,
      cdTransportadora: veiculo!.cdTransportadora!,
      cdVeiculo: veiculo!.cdVeiculo!,
      dadosAdicionaisViagem: dadosAdicionaisViagem,
    }
  }

  const verificaHorariosDisponiveis = () => {
    const dataMinima: moment.Moment = moment()
    // const horas: number = dataMinima.hours()
    // const minutos: number = dataMinima.minutes()

    // dataMinima.set('hour', minutos > 0 ? horas + 2 : horas + 1)
    dataMinima.set('minute', 0)
    dataMinima.set('second', 0)
    dataMinima.set('millisecond', 0)

    setSelectHorarioItens(
      horarios
        .filter(
          (horario) =>
            horario.cdAgendamentoDocasJanela === cdJanela &&
            horario.cdAgendamendoDocasDocas === cdDoca,
        )
        .map((horario: IHorario) => {
          return {
            value: horario.cdAgendamentoDocasHorario.toString(),
            label: horario.hora,
            disabled:
              moment(horario.dtHora, 'YYYY-MM-DDTHH:mm:ss') < dataMinima,
          }
        }),
    )
  }

  const atualizaPlaca = (placa: string) => {
    setPlaca1(placa.toUpperCase())

    if (criarVeiculo) {
      setCriarVeiculo(false)
    }

    if (veiculo) {
      setVeiculo(undefined)
    }
  }

  useEffect(() => {
    getAgendaSimplificada()
  }, [docasContext.armazemAtual, docasContext.dataAtual, agendamentos.length])

  useEffect(() => {
    verificaHorariosDisponiveis()
  }, [cdJanela, cdDoca])

  return isAuthorized(Claims.ReservarHorario) ? (
    <Form
      form={form}
      onFinish={reservaHorarios}
      layout="vertical"
      style={{ width: '100%' }}
    >
      <Row gutter={16}>
        <Col span={8}>
          <SelectFieldAnt
            methods={hookForm}
            scope="form-modo-compacto"
            label="Janela:"
            name="cdJanela"
            items={selectJanelaItens}
            onChangeValue={(cdJanela: string) =>
              setCdJanela(window.parseInt(cdJanela))
            }
            showSearch={true}
            disabled={carregandoAgendaSimplificada}
            rules={[{ required: true, message: 'Campo obrigatório' }]}
          />
        </Col>

        <Col span={8}>
          <SelectFieldAnt
            methods={hookForm}
            scope="form-modo-compacto"
            label="Doca:"
            name="cdDoca"
            items={selectDocaItens}
            onChangeValue={(cdDoca: string) =>
              setCdDoca(window.parseInt(cdDoca))
            }
            showSearch={true}
            disabled={carregandoAgendaSimplificada}
            rules={[{ required: true, message: 'Campo obrigatório' }]}
          />
        </Col>

        <Col span={8}>
          <SelectFieldAnt
            methods={hookForm}
            scope="form-modo-compacto"
            label="Horário:"
            name="cdsHorarios"
            items={selectHorarioItens}
            mode="multiple"
            showSearch={true}
            disabled={!cdJanela || !cdDoca}
            rules={[{ required: true, message: 'Campo obrigatório' }]}
          />
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="numeroLoad"
            label="Número do Load:"
            //rules={[{ required: true, message: 'Campo obrigatório' }]}
          >
            <Input type="text" style={{ textTransform: 'uppercase' }} />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            name="destino"
            label="Destino:"
            //rules={[{ required: true, message: 'Campo obrigatório' }]}
          >
            <Input type="text" style={{ textTransform: 'uppercase' }} />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            name="motorista"
            label="Motorista:"
            //rules={[{ required: true, message: 'Campo obrigatório' }]}
          >
            <Input type="text" style={{ textTransform: 'uppercase' }} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={8}>
          <Form.Item
            name="placa"
            label="Placa 1:"
            rules={[{ required: true, message: 'Campo obrigatório' }]}
          >
            <Input
              maxLength={7}
              style={{ textTransform: 'uppercase' }}
              type="text"
              onChange={(e) => atualizaPlaca(e.target.value)}
            />
          </Form.Item>
          {cdTransportadoraUsuario && veiculo && (
            <div>Transportadora: {veiculo.transportadora}</div>
          )}
        </Col>

        <Col span={8}>
          <Form.Item
            name="placa2"
            label="Placa 2:"
            //rules={[{ required: true, message: 'Campo obrigatório' }]}
          >
            <Input
              maxLength={7}
              style={{ textTransform: 'uppercase' }}
              type="text"
              onChange={(e) => setPlaca2(e.target.value.toUpperCase())}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            name="tipoVeiculo"
            label="Tipo do Veículo:"
            //rules={[{ required: true, message: 'Campo obrigatório' }]}
          >
            <Input style={{ textTransform: 'uppercase' }} type="text" />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        {!cdTransportadoraUsuario && (
          <Col span={8}>
            <SelectFieldAnt
              methods={hookForm}
              scope="form-modo-compacto"
              label="Transportadora:"
              name="cdTransportadora"
              items={selectTransportadoraItens}
              showSearch={true}
              onChangeValue={(value: string) =>
                setCdTransportadora(window.parseInt(value))
              }
              rules={[{ required: true, message: 'Campo obrigatório' }]}
            />
          </Col>
        )}

        <Col span={8}>
          <Button
            type="primary"
            style={{ marginTop: '30.5px' }}
            onClick={() => verificaVeiculo()}
            disabled={!cdTransportadora || placa1?.length !== 7}
            loading={verificandoVeiculo}
          >
            Verificar
          </Button>

          <Button
            type="primary"
            style={{ marginTop: '30.5px', marginLeft: '16px' }}
            onClick={() => criaVeiculo()}
            disabled={!criarVeiculo}
            loading={criandoVeiculo}
          >
            Criar
          </Button>

          <Button
            type="primary"
            htmlType="submit"
            loading={carregandoReservaHorario}
            style={{ marginTop: '30.5px', marginLeft: '16px' }}
          >
            Reservar
          </Button>

          {isAuthorized(Claims.ReservarAprovarHorario) && (
            <Button
              type="primary"
              htmlType="submit"
              loading={carregandoReservaHorario}
              style={{ marginTop: '30.5px', marginLeft: '16px' }}
              onClick={() => setReservarAprovar(true)}
            >
              Reservar e Aprovar
            </Button>
          )}
        </Col>
      </Row>
    </Form>
  ) : (
    <div style={{ color: 'red', marginBottom: '10px' }}>
      Você não tem permissão para reservar horários
    </div>
  )
}

export default ModoCompactoIraniFob
